import { useSelector } from 'react-redux';
import type { RootState } from 'store';
import type { MetricType } from 'store/settings/types';

/**
 * Hook to get the current metric type setting.
 * Returns the configured metric type (METRIC_SQUARE, METRIC_ROUND, or IMPERIAL).
 */
export const useMetricType = (): MetricType => {
  const { metricType } = useSelector((state: RootState) => state.settingsState);
  return metricType;
};
